<template lang="pug">
  .d-case
    img.top-img(src="~assets/case/01/img1.png")
    .content
      .case-num Vol.01
      .case-title 有风景也有爱，建筑师夫妇把140㎡家打造成让人羡慕的样子
      .line1 2017年夏天，建筑师一横和太太在上海松江买下了属于自己的第一套房。作为建筑师夫妇，在工作中为业主贡献了无数极具创意和设计感的作品，而在面对自己的家时，他们选择了大白墙为主的极简。
      .line1 “每天的工作都要在无数的审美中选择，回家后只想要简单。于是我们从设计一开始就定下了设计原则：最少的装饰，最功能化的家具，最省事的家务。”
      img.cont-img(src="~assets/case/01/img2.png")
      .cont-title 「背景信息」
      .line1 <span>关于屋主</span>屋主夫妇两人都是建筑师，男主人一横擅于空间整体规划及硬装打磨，女主人则喜欢研究软装功能与色彩搭配。他们信奉密斯·凡德罗Less is more的设计理念，共同打造的家，充满了极简美学和功能主义。
      .cont-title 「房子的基本信息」
      .line1
        <span>坐标：上海松江</span>
        <span>户型：四室两厅</span>
        <span>使用面积：140㎡</span>
        <span>装修风格：现代极简</span>
        <span>装修费用：40w+</span>
      img.cont-img(src="~assets/case/01/img3.png")
      .cont-title 客餐厅：坐拥三面环景
      .line1 拿到房子以后，一横首先想到的就是将客餐厅打通，并将南阳台包进客厅，形成一个宽敞的、坐拥三面环景的公共区域，最大程度将河景引入室内。白墙基调是窗外风景的最佳图底，公共空间最大化，邀请再多朋友来家Party也不怕。
      img.cont-img(src="~assets/case/01/img4.png")
      .line1 大面积的落地窗，将室内外连为一体。配上可调节光线香格里拉帘，既有百叶一般的光影效果，又方便打理不怕积灰，再加一层白色纱帘，颜值与实用性都可兼顾。
      img.cont-img(src="~assets/case/01/img5.png")
      .line1 白色的墙面与素雅的木纹砖地面，奠定了客餐厅极简的格调，软装的选用则在功能和色彩上做到实用与美观。
      .line1 "我们对家具的选择比较挑剔，喜欢具有实用性与品质感，同时兼具设计感与性价比的。"说到买家具的经历，夫妻俩在某宝有过多次货不对版的坑，后来经朋友介绍来到懂窝，发现这里的家具与他们的观念不谋而合。
      img.cont-img(src="~assets/case/01/img6.png")
      .line1 懂窝维特罗吊灯，星星点点的灯光像花瓣一样，中和极简的设计风格，让整体氛围变得温馨浪漫。
      img.cont-img(src="~assets/case/01/img7.png")
      .line1 与大体量的沙发形成对比，茶几则选用轻盈的金属元素，精致的平行拉丝和环状拉丝，纹理与材质的细微差别，时尚耐看。
      img.cont-img(src="~assets/case/01/img8.png")
      .line1 窗边放一把经典蝴蝶椅，搭配一张懂窝桑德罗羊皮毯，在充满北欧气息的大叶绿植簇拥下，向大师设计致敬，更为自己营造一方闲适空间。
      img.cont-img(src="~assets/case/01/img9.png")
      .line1 客厅与餐厅之间，以一件蓝灰色的矮柜作为空间过渡，也是入门玄关的视觉落脚点，是一横亲手设计定制的。简约的柜体，加上黄铜底座，轻奢好看。
      img.cont-img(src="~assets/case/01/img10.png")
      .line1 餐厅遵循简约的设计。懂窝马利克斯餐桌，实木质感温润，冬夏季都有最佳的触感，搭配黄铜桌脚，时尚轻盈。高低排布的吊灯及像圆月般饱满的落地灯，则为用餐提供恰到好处的光源，让气氛更加舒适。
      img.cont-img(src="~assets/case/01/img11.png")
      .cont-title 厨房：橱柜量身定制
      .line1 厨房与客餐厅相连，带有金属质感的橱柜精致大气，也是一横自己画图、根据家人身高定做的。台柜高度87cm，这样切菜洗碗都不会太累。橱柜下面有可自动感应的灯带，可以从外面控制开关。
      img.cont-img(src="~assets/case/01/img12.png")
      .line1 洗碗机、净水器等电器在最初设计时就被规划入整体橱柜中，加上免拉手的抽屉，在厨房这种重油烟的区域没有一处死角。
      .cont-title 玄关：一个多功能柜体
      .line1 一个完整精密的收纳系统，是夫妻俩设计这个家的主要考虑之一。为此，一横亲手画图设计了全屋柜体，主要的宗旨是：外无负担，内有乾坤。
      .line1 进门右侧是玄关柜，上部吊柜，放置不常用的杂物；下部高低两个柜体，可以用来放鞋子，中间凹进的部分，刚好可以坐着换鞋。中间设置隐藏的感应灯带。柜体与地面悬空，不仅可以放日常的鞋子，还能让扫地机器人通过。
      img.cont-img(src="~assets/case/01/img13.png")
      .line1 作为玄关延伸的一部分，一面简约的穿衣镜，一幅落地的挂画，让主卧与走廊之间的色彩产生有趣的对话。
      img.cont-img(src="~assets/case/01/img14.png")
      .cont-title 主卧：套房设计，收纳力max
      .line1 主卧与主卫、儿童房呈套房设计。
      img.cont-img(src="~assets/case/01/img15.png")
      .line1 主卧有别于客厅的白墙，选择了多乐士的午夜蓝，静谧、深邃如夜空。地板上墙作为床头板，将墙面黄金分割。床头隐藏灯带，加上垂坠的床头灯，让卧室的氛围显得安静而舒适，更加有利于睡眠。
      img.cont-img(src="~assets/case/01/img16.png")
      .line1 主卧内利用墙体凹进的600公分的深度，做了4.8米长的整面柜体。270°的铰链，可以让柜体开门最大化，拿取衣物更加方便。
      .line1 衣柜内搁板可以根据衣物长短进行调节，内置感应灯带，方便衣物挂取。为了杜绝卫生死角，床底架空，方便扫地机器人通过。
      img.cont-img(src="~assets/case/01/img17.png")
      .cont-title 主卫：优雅爵士白
      .line1 用爵士白砖铺设主卫，简约明亮。大小两个镜面的设置，方便夫妻俩同时使用。
      img.cont-img(src="~assets/case/01/img18.png")
      .line1 蓝灰色的浴室柜也是自己画图定制，台盆半挂，做了400的进深，加上圆镜边缘的灯光，可以带来模拟自然光的效果，方便化妆。
      .line1 浴室柜底部做了搁板，可以放置脏衣篮。同时离地面有一定高度，扫地机器人可以通过。
      .cont-title 书房：建筑师的温馨日常
      .line1 书房在进门左侧，这里是两个人的工作空间，也是一个临时客卧（用一张沙发床来实现）。
      img.cont-img(src="~assets/case/01/img19.png")
      .line1 一横画图设计了一张3米左右的书桌，满足夫妻俩同时工作的需求。书桌下除了常见的抽屉柜体外，预留了收纳推车（篮子）的空间，可以用来放文件和打印纸等。同时，书房也预留了整整一面墙给未来的书架。
      .line1 “有的时候设计不能做的太满，未来总是充满了不确定，给设计留点白，也是给自己的生活留点小期盼。” 
      img.cont-img(src="~assets/case/01/img20.png")
      .line1 现在，一横夫妇已经搬进新家大半年了，无论工作有多辛苦，他们都知道家里有一份简单温馨在等候。每天就着朝霞吃早餐，伴着晚霞做晚饭，厨房不弯腰，没有油烟，连一横也爱上了做饭。每周放扫地机器人出来溜溜，看到看不到的地方都干干净净。
      img.cont-img(src="~assets/case/01/img21.png")
      .line1 “很多时候，设计不仅仅只是好看与否，好的设计既可以带给你美的享受，还可以改善你的生活，让你开始享受生活。”
      .cont-title 软装搭配心得
      .line1 •  不要单纯看一件单品的好看与否，而是看功能与整体风格的协调性。<br/> • 细腿儿的家具可以让地面露出的部分更多，让空间看起来更大。同时也可以让扫地机器人通过，减少做家务的时间。<br/> •  定制全屋柜体，充分考虑使用细节，可以将杂物尽量收起来，不影响整体简约的格调。
    img.scroll-top-btn(v-show="scrollTop", @click="backtop", src="~assets/goTop.png")

</template>

<script>
export default {
  data() {
    return {
      scrollTop: false
    }
  },
  mounted () {
    window.addEventListener("scroll", this.showbtn, true);
  },
  methods: {
    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
};
</script>

<style lang="sass" scoped>
@import 'config'
.d-case
  width: 100%
  position: relative
  padding-top: 0.1px
  .top-img
    width: 100%
    position: absolute
    z-index: -1
  .content
    margin: r(869) auto 0
    width: r(1020)
    // height: r(300)
    background: #ffffff
    padding-top: 0.1px
    padding-bottom: r(350)
    .case-num
      margin: r(43) auto
      width: r(844)
      font-family: PingFangSC-Regular
      font-size: r(20)
      color: #717273
      letter-spacing: 0
    .case-title
      margin: r(18) auto r(50)
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #070809
      line-height: r(60)
    .line1
      margin: r(30) auto
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #585858
      line-height: r(34)
      span
        display: block
        text-align: center
    .cont-img
      margin-top: r(60)
      width: 100%
    .cont-title
      font-weight: bolder
      margin-top: r(64)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #070809
      text-align: center
  .scroll-top-btn
    position: fixed
    z-index: 100
    bottom: r(100)
    right: r(100)
    width: r(80)
</style>



// WEBPACK FOOTER //
// case1.vue?04163856